export const DASHBOARD_COLORS = [
  '#6366F1', // Apple Indigo
  '#F59E0B', // Apple Amber
  '#10B981', // Apple Mint/Emerald
  '#3B82F6', // Apple Blue
  '#F43F5E', // Apple Coral/Rose
  '#8B5CF6', // Apple Purple
  '#06B6D4', // Apple Teal
  '#0EA5E9', // Apple Sky
  '#EC4899', // Apple Pink
  '#14B8A6', // Apple Mint Dark
];
